import { useCartBrand } from "@faire/retailer-visitor-shared/views/brand/BrandCart/hooks/useCartBrand";
import { useMemo } from "react";
export var useNumberOfItemsInCart = function(brandToken) {
    var cartBrand = useCartBrand(brandToken);
    var numberOfItemsInCart = useMemo(function() {
        var _cartBrand_cart_items;
        return Object.values((_cartBrand_cart_items = cartBrand === null || cartBrand === void 0 ? void 0 : cartBrand.cart_items) !== null && _cartBrand_cart_items !== void 0 ? _cartBrand_cart_items : {}).length;
    }, [
        cartBrand
    ]);
    return numberOfItemsInCart;
};
